export class CommissionsSignalmanModel {
  public id: number;
  public tipoVendita: string;
  public percentualeProvvigione: number;
  public enabled: boolean;
  public creator: string;
  public created: Date;
  public modifier: string;
  public modified: Date;
}
